import { render } from "./RecipeList.vue?vue&type=template&id=3c85009e&scoped=true"
import script from "./RecipeList.vue?vue&type=script&lang=js"
export * from "./RecipeList.vue?vue&type=script&lang=js"

import "./RecipeList.vue?vue&type=style&index=0&id=3c85009e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c85009e"]])

export default __exports__